import { render, staticRenderFns } from "./AdminProductContent.vue?vue&type=template&id=d2329aa2&scoped=true&"
import script from "./AdminProductContent.vue?vue&type=script&lang=js&"
export * from "./AdminProductContent.vue?vue&type=script&lang=js&"
import style0 from "./AdminProductContent.vue?vue&type=style&index=0&id=d2329aa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2329aa2",
  null
  
)

export default component.exports